<template>
    <div class="rwa_menu">
        <div class="rwa_menu_all">

            <div class="rwa_menu_all01">
                <img src="../assets/images/rwaLogo.png" class="rwa_menu_01"/>
                <img src="../assets/images/menu_logo.png" @click="handleClose" class="rwa_menu_02"/>
            </div>

            <div class="rwa_menu_all03">
                <div class="rwa_menu_02">
                  <div :class="menuIndex === 1 ? 'rwa_menu_0201 rwa_menu_02_select' : 'rwa_menu_0201'" @click="toMenuPage(1)">{{ lang('home') }}</div>
                  <div :class="menuIndex === 2 ? 'rwa_menu_0201 rwa_menu_02_select' : 'rwa_menu_0201'" @click="toMenuPage(2)">{{ lang('wkuang') }}</div>
                  <div :class="menuIndex === 3 ? 'rwa_menu_0201 rwa_menu_02_select' : 'rwa_menu_0201'" @click="toMenuPage(3)">交割</div>
                  <div :class="menuIndex === 4 ? 'rwa_menu_0201 rwa_menu_02_select' : 'rwa_menu_0201'" @click="toMenuPage(4)">Launch</div>
                  <div :class="menuIndex === 5 ? 'rwa_menu_0201 rwa_menu_02_select' : 'rwa_menu_0201'" @click="toMenuPage(5)" v-if="$store.state.accounts.length > 0 && $store.state.accounts[0].toLowerCase() === '0x9a60bfa78c21e61fbcc1fa5af7a8a338f7907eec'">发布古董</div>
                </div>
            </div>

            <div class="rwa_menu_all02">
                <div class="rwa_menu_all02_lxlogo">
                  <a @click="openPDF()"><img src="../assets/images/wbook.png"/></a>
                  <a href="https://t.me/rwaartinc" target="_blank"><img src="../assets/images/tg.png"/></a>
                  <a href="https://x.com/rwaartinc" target="_blank"><img src="../assets/images/tt.png"/></a>
                </div>
                <div class="rwa_menu_yuyan">
                  <div class="rwa_menu_yuyan_01" @click="onSelectYuyan()">
                    <img class="rwa_menu_yuyan_011" src="../assets/images/inter.png"/>
                    <div class="rwa_menu_yuyan_012">{{$store.state.languageType === 'en' ? 'English' : '中文'}}</div>
                    <img class="rwa_menu_yuyan_013" src="../assets/images/fxxia.png"/>
                  </div>
                  <div class="rwa_menu_yuyan_02" v-if="isSelectYuyan">
                    <div class="rwa_menu_yuyan_021" @click="onSelectYuyan('cn')">中文</div>
                    <div class="rwa_menu_yuyan_022" @click="onSelectYuyan('en')">English</div>
                  </div>
                </div>
                <div class="rwa_menu_wallet">
                    <div class="rwa_menu_04" :style="$store.state.accounts.length > 0 ? 'background: linear-gradient(270deg, #F9C53D 1%, #1CFE5E 100%);' : ''" @click="openConnectWallet()">
                        {{$store.state.accounts.length === 0 ? lang('conwall') : ''}}
                        <div class="rwa_menu_041" v-show="$store.state.accounts.length > 0">
                            <div class="rwa_menu_0412">
                              <div class="rwa_menu_0411"></div>
                              <div>{{cutAccount($store.state.accounts[0], 5)}}</div>
                            </div>
                            <img class="rwa_menu_0413" v-if="$store.state.walletType===0" src="../assets/images/okb.png"/>
                            <img class="rwa_menu_0413" v-if="$store.state.walletType===1" src="../assets/images/metaMask.png"/>
                            <img class="rwa_menu_0413" v-if="$store.state.walletType===2" src="../assets/images/tp.png"/>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <el-drawer
            :visible.sync="menuDrawer"
            direction="rtl"
            size="80%"
            :before-close="handleClose">
          <div class="menu_drawer_div">
            <div class="menu_drawer_div1">
              <div class="menu_drawer_div11" @click="toMenuPage(1)">{{ lang('home') }}</div>
              <div class="menu_drawer_div11" @click="toMenuPage(2)">{{ lang('wkuang') }}</div>
              <div class="menu_drawer_div11" @click="toMenuPage(3)">交割</div>
              <div class="menu_drawer_div11" @click="toMenuPage(4)">Launch</div>
              <div v-if="$store.state.accounts.length > 0 && $store.state.accounts[0].toLowerCase() === '0x9a60bfa78c21e61fbcc1fa5af7a8a338f7907eec'" class="menu_drawer_div11" @click="toMenuPage(5)">发布古董</div>
            </div>

            <div class="menu_drawer_div2">
              <div class="menu_drawer_div21" :style="$store.state.accounts.length > 0 ? 'background: linear-gradient(270deg, #F9C53D 1%, #1CFE5E 100%);' : ''" @click="openConnectWallet()">
                {{$store.state.accounts.length === 0 ? lang('conwall') : ''}}
                <div class="menu_drawer_div211" v-show="$store.state.accounts.length > 0">
                  <div class="menu_drawer_div2111">{{cutAccount($store.state.accounts[0], 5)}}</div>
                  <img class="menu_drawer_div2112" v-if="$store.state.walletType===0" src="../assets/images/okb.png"/>
                  <img class="menu_drawer_div2112" v-if="$store.state.walletType===1" src="../assets/images/metaMask.png"/>
                  <img class="menu_drawer_div2112" v-if="$store.state.walletType===2" src="../assets/images/tp.png"/>
                </div>
              </div>
              <div class="menu_drawer_div22">
                <div class="menu_drawer_div221" @click="onSelectYuyan()">
                  <img class="menu_drawer_div2211" src="../assets/images/inter.png"/>
                  <div class="menu_drawer_div2212">{{$store.state.languageType === 'en' ? 'English' : '中文'}}</div>
                  <img class="menu_drawer_div2213" src="../assets/images/fxxia.png"/>
                </div>
                <div class="menu_drawer_div222" v-if="isSelectYuyan">
                  <div class="menu_drawer_div2221" @click="onSelectYuyan('cn')">中文</div>
                  <div class="menu_drawer_div2222" @click="onSelectYuyan('en')">English</div>
                </div>
              </div>
            </div>
          </div>
        </el-drawer>

        <ConnectWallet/>
        <MetaDialog/>
    </div>
</template>

<script>
    import {cutAccount, lang} from '../tools/index';
    import ConnectWallet from "../components/ConnectWallet";
    import MetaDialog from "../components/MetaDialog";
    import transfer from "../tools/transfer";

    export default {
        name: "Menu",
        components: { ConnectWallet, MetaDialog },
        data() {
            return {
                menuIndex: 2,
                isSelectYuyan: false,
                menuDrawer: false
            }
        },
        watch: {},
        created() {
            transfer.$on("toMenuPage", (page) => {
                this.toMenuPage(page);
            });

            transfer.$on("setMenuIndex", (page) => {
              this.setMenuIndex(page);
            });

            transfer.$on('onSelectYuyan', () => {
                this.onSelectYuyan();
            })
        },
        mounted() {
            this.initMenuPage();
        },
        destroyed() {
        },
        methods: {
            lang(key){
              return lang(key);
            },
            onSelectYuyan(val) {
                this.isSelectYuyan = !this.isSelectYuyan;

                if (val) {
                  this.$store.commit('setState', {
                    languageType: val
                  });

                  this.$i18n.locale = val;
                }
            },
            openConnectWallet() {
              this.$store.commit('setState', {
                connectWalletShow: true
              });
            },
            cutAccount(account, num) {
                return cutAccount(account, num);
            },
            openPDF() {
                if (this.$store.state.languageType === 'cn') {
                  window.open('/static/file/RWA.ART_CN.pdf', '_blank');
                } else {
                  window.open('/static/file/RWA.ART_EN.pdf', '_blank');
                }
            },
            initMenuPage() {
                if (sessionStorage.getItem('menuIndex')) {
                    this.menuIndex = parseInt(sessionStorage.getItem('menuIndex'));
                } else {
                    if (this.$route.path.toString().indexOf('/index') >= 0) {
                        this.toMenuPage(1);
                    } else {
                        this.toMenuPage(1);
                    }
                }
            },
            toMenuPage(page) {
                this.menuDrawer = false;

                if (page === 1) {
                    this.$router.push("/index");
                    sessionStorage.setItem('isMiningShow', '0');

                    transfer.$emit("initPageData");
                } else if (page === 2) {
                    window.open("https://rwabank.art/#/index", "_blank");
                } else if (page === 3) {
                    if (this.$store.state.accounts.length === 0) {
                        this.$message.warning(lang('qxljqb'));

                        setTimeout(() => {
                            this.openConnectWallet();
                        }, 1000);
                        return;
                    }

                    // this.$message.warning('Coming soon!');
                    // return;
                    this.$router.push("/delivery");
                } else if (page === 4) {
                    this.$router.push("/launch");
                } else if (page === 5) {
                  if (this.$store.state.accounts.length > 0 && this.$store.state.accounts[0].toLowerCase() === '0x9a60bfa78c21e61fbcc1fa5af7a8a338f7907eec') {
                    this.$router.push("/publish");
                  } else {
                    this.$message.warning('Coming soon!');
                    return;
                  }
                } else if (page === 6) {
                  if (this.$store.state.accounts.length === 0) {
                    this.$message.warning(lang('qxljqb'));

                    setTimeout(() => {
                      this.openConnectWallet();
                    }, 1000);
                    return;
                  }

                  this.$router.push("/collection");
                } else {
                    this.$message.warning('Coming soon!');
                    return;
                }

                if (page !== 2) {
                  this.menuIndex = page;
                  sessionStorage.setItem('menuIndex', page);

                  transfer.$emit("initBottomClass");
                }
            },
            setMenuIndex(page) {
                this.menuIndex = page;
                sessionStorage.setItem('menuIndex', page);

                transfer.$emit("initBottomClass");
            },
            handleClose() {
                this.menuDrawer = !this.menuDrawer;
            }
        }
    }
</script>

<style lang="less">
    .rwa_menu {
        width: 100%;
        height: 84px;
        background: #001601;
        .rwa_menu_all {
            width: 80%;
            height: 84px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            margin-left: 10%;
            .rwa_menu_all01 {
                // cursor: pointer;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                @media (max-width: 767px) {
                  justify-content: space-between;
                  width: 100%;
                }
                .rwa_menu_01 {
                    width: 168px;
                }
                .rwa_menu_02 {
                  display: none;
                  @media (max-width: 767px) {
                    display: block;
                    cursor: pointer;
                  }
                }
            }
            .rwa_menu_all02 {
                height: 45px;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-end;
                align-items: center;
                @media (max-width: 767px) {
                  display: none;
                }
                .rwa_menu_all02_lxlogo {
                  margin-right: 15px;
                  a {
                    margin: 0 3px;
                    img {
                      width: 30px;
                      margin-top: 5px;
                      cursor: pointer;
                    }
                  }
                }
                .rwa_menu_yuyan {
                  position: relative;
                  margin-right: 20px;
                  .rwa_menu_yuyan_01 {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    width: 135px;
                    height: 40px;
                    border-radius: 8px;
                    background: #000;
                    //background: linear-gradient(270deg, #F9C53D 1%, #1CFE5E 100%);
                    border-radius: 10px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                    //font-weight: bold;
                    color: white;
                    cursor: pointer;
                    &:hover {
                      //background: linear-gradient(270deg, #F9C53D 20%, #1CFE5E 100%);
                    }
                    .rwa_menu_yuyan_011 {
                      width: 27px;
                    }
                    .rwa_menu_yuyan_012 {
                      width: 50px;
                      text-align: right;
                      margin: 0 7px;
                    }
                    .rwa_menu_yuyan_013 {
                      width: 13px;
                    }
                  }
                  .rwa_menu_yuyan_02 {
                    position: absolute;
                    z-index: 1000;
                    margin-top: 10px;
                    width: 135px;
                    height: 84px;
                    background: #4D4D4D;
                    border-radius: 10px;
                    border: 2px solid #20944B;
                    .rwa_menu_yuyan_021 {
                      display: flex;
                      height: 40px;
                      padding: 12px 10px;
                      justify-content: center;
                      align-items: center;
                      gap: 10px;
                      align-self: stretch;
                      color: white;
                      border-bottom: 1px solid #999;
                      background: #4D4D4D;
                      cursor: pointer;
                      border-top-left-radius: 10px;
                      border-top-right-radius: 10px;
                      &:hover {
                        color: #20944B;
                      }
                    }
                    .rwa_menu_yuyan_022 {
                      display: flex;
                      height: 41px;
                      padding: 12px 10px;
                      justify-content: center;
                      align-items: center;
                      gap: 10px;
                      align-self: stretch;
                      color: white;
                      border-bottom: 1px solid #20944B;
                      background: #4D4D4D;
                      cursor: pointer;
                      border-bottom-left-radius: 10px;
                      border-bottom-right-radius: 10px;
                      &:hover {
                        color: #20944B;
                      }
                    }
                  }
                }
                .rwa_menu_wallet {
                    position: relative;
                    .rwa_menu_04 {
                        width: 180px;
                        height: 40px;
                        //background: linear-gradient(270deg, #F9C53D 1%, #1CFE5E 100%);
                        background: linear-gradient( 270deg, #20944B 0%, #2FA637 100%);
                        border-radius: 10px;
                        text-align: center;
                        line-height: 40px;
                        font-size: 16px;
                        //font-weight: bold;
                        color: white;
                        cursor: pointer;
                        &:hover {
                            //background: linear-gradient(270deg, #F9C53D 20%, #1CFE5E 100%);
                            background: linear-gradient( 270deg, #20944B 5%, #2FA637 100%);
                        }
                        .rwa_menu_041 {
                            display: flex;
                            flex-direction: row;
                            flex-wrap: nowrap;
                            justify-content: space-around;
                            align-items: center;
                            width: 180px;
                            .rwa_menu_0412 {
                                color: black;
                                display: flex;
                                flex-direction: row;
                                flex-wrap: nowrap;
                                align-items: center;
                                justify-content: flex-start;
                                .rwa_menu_0411 {
                                  width: 8px;
                                  height: 8px;
                                  background: #f38a00;
                                  border-radius: 50%;
                                  opacity: 1;
                                  margin-right: 5px;
                                }
                            }
                            .rwa_menu_0413 {
                                width: 25px;
                            }
                        }
                    }
                }
            }
            .rwa_menu_all03 {
                @media (max-width: 767px) {
                  display: none;
                }
                .rwa_menu_02 {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: flex-start;
                    align-items: center;
                    .rwa_menu_0201:hover {
                        color: white;
                    }
                    .rwa_menu_0201 {
                        //width: 68px;
                        height: 40px;
                        line-height: 40px;
                        margin: 0 20px;
                        font-size: 14px;
                        color: #727272;
                        cursor: pointer;
                        text-align: center;
                    }
                    .rwa_menu_02_select {
                        line-height: 40px !important;
                        color: white !important;
                        //border: 1px solid #727272;
                        border-radius: 10px;
                    }
                }
            }
        }
    }
</style>

<style>
.el-drawer {
  background-color: black!important;
}
.menu_drawer_div {
  color: white;
  .menu_drawer_div1 {
    width: 100%;
    .menu_drawer_div11 {
      width: 80%;
      margin-left: 10%;
      font-size: 20px;
      line-height: 65px;
      height: 65px;
      border-bottom: 2px solid #1d7f02;
    }
  }
  .menu_drawer_div2 {
    margin-left: 10%;
    margin-top: 45px;
    .menu_drawer_div21 {
      width: 200px;
      height: 60px;
      background: linear-gradient( 270deg, #20944B 0%, #2FA637 100%);
      border-radius: 10px;
      text-align: center;
      line-height: 60px;
      font-size: 18px;
      color: white;
      cursor: pointer;
      .menu_drawer_div211 {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        .menu_drawer_div2111 {
          margin-left: 15px;
        }
        .menu_drawer_div2112 {
          width: 30px;
          margin-right: 10px;
        }
      }
    }
    .menu_drawer_div22 {
      position: relative;
      margin-right: 20px;
      margin-top: 30px;
      .menu_drawer_div221 {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 60px;
        background: linear-gradient( 270deg, #20944B 0%, #2FA637 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 60px;
        font-size: 18px;
        color: white;
        cursor: pointer;
        .menu_drawer_div2211 {
          width: 27px;
        }
        .menu_drawer_div2212 {
          margin: 0 7px;
        }
        .menu_drawer_div2213 {
          width: 13px;
        }
      }
      .menu_drawer_div222 {
        position: absolute;
        z-index: 1000;
        margin-top: 10px;
        width: 200px;
        height: 104px;
        background: #4D4D4D;
        border-radius: 10px;
        border: 2px solid #20944B;
        .menu_drawer_div2221 {
          display: flex;
          height: 50px;
          padding: 12px 10px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
          color: white;
          border-bottom: 1px solid #999;
          background: #4D4D4D;
          cursor: pointer;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
        .menu_drawer_div2222 {
          display: flex;
          height: 52px;
          padding: 12px 10px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
          color: white;
          border-bottom: 1px solid #20944B;
          background: #4D4D4D;
          cursor: pointer;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
    }
  }
}
</style>
